export default class EventHandlerVideoModule {
  constructor(resizer) {
    this.overlay = resizer.overlay;
    this.vid = resizer.vid;
    this.options = resizer.options;
    this.requestUpdate = resizer.onUpdate;
  }

  calculateVideo() {
    const { vid } = this;
    const { editor } = this.options.vm;
    const { scrollingContainer } = editor;
    const vidWidth = vid.getAttribute('width');
    const vidHeight = vid.getAttribute('height');
    const decimal = vidWidth / scrollingContainer.offsetWidth;
    vid.setAttribute('data-decimal-width', decimal <= 1 ? decimal : 1);
    vid.setAttribute('aspect-ratio', vidHeight / vidWidth);
  }

  onCreate() {
    this.options.vm.isResizing = true;
  }

  onDestroy() {
    this.calculateVideo();
    this.options.vm.isResizing = false;
    this.options.vm.onEditorChange();
  }

  onUpdate() {
    this.options.vm.isResizing = true;
  }
}
